import { UseBalanceAction } from '@did/das-balance-types'
import { ORDER_ACTION_TYPE } from '@did/types'
import { useState } from 'react'

export const useBalanceAction: UseBalanceAction = (param) => {
  const [receiveShow, setReceiveShow] = useState(false)
  const [sendShow, setSendShow] = useState(false)
  const [txHash, setTxHash] = useState('')
  const [txHashLink, setTxHashLink] = useState('')
  const [transferSubmittedDialogShowing, setTransferSubmittedDialogShowing] =
    useState(false)
  const [actionList, setActionList] = useState<ORDER_ACTION_TYPE[]>([])

  const handleActionSuccess = (data: {
    txHashLink: string
    txHash: string
    actionType: ORDER_ACTION_TYPE
  }) => {
    setTxHash(data.txHash)
    setTxHashLink(data.txHashLink)
    setSendShow(false)
    setTransferSubmittedDialogShowing(true)
    param?.onSucess?.()
    setActionList([data.actionType])
  }

  const handleSubmittedDialogClose = () => {
    setTxHash('')
    setTxHashLink('')
    setTransferSubmittedDialogShowing(false)
    setActionList([])
  }

  return {
    handleActionSuccess,
    receiveShow,
    setReceiveShow,
    sendShow,
    setSendShow,
    transferSubmittedDialogShowing,
    handleSubmittedDialogClose,
    txHash,
    txHashLink,
    actionList
  }
}
